let grid = [
  {
    title: '付帅云播报—FY200',
    h4: [
      '2G/WIFI/4G联网，联网更稳定，',
      '脱离手机使用，网络自动切换，',
      '没有WIFI也能用。'
    ],
    imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_f_01.png'
  },

  {
    title: '付帅云播报—FY200',
    h4: [
      '高容量电池，超长待机时间，',
      '自带充电电池，充电用两天，',
      '没有电源的地方也能用。'
    ],
    imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_f_04.png'
  },
  {
    title: '付帅云播报—FY200',
    h4: [
      'AI智能文字转语音，想播什么，就播什么，',
      '内置TTS离线转换，无需网络合成速度更快。'
    ],
    imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_f_02.png'
  },
  {
    title: '付帅云播报—FY200',
    h4: [
      '分体式设计，码牌可粘贴到喇叭挡板，',
      '也可单独粘贴。'
    ],
    imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_f_03.png'
  },
]

export default grid



// WEBPACK FOOTER //
// ./src/assets/conf/hard_grid.js